import "./CustomDateBox.css";
import { DateBox } from "devextreme-react/date-box"
import { Validator, RequiredRule } from "devextreme-react/validator"
import React from "react";
import { isWeekend, isHoliday } from "./utils/dateUtils"
import { formatDate } from 'devextreme/localization';

interface IProps {
    min?: Date;
    max?: Date;
    value: Date;
    label: string;
    holidays?: Array<Date>;
    onValueChanged: (value: Date) => void;
    className?: string;
    name?: string;
    hint?: string;
    stylingMode?: "filled" | "outlined" | "underlined";
}

const dateFormatter = (e: Date) => formatDate(e, { year: 'numeric', month: '2-digit', day: '2-digit' } as any);

const CustomDateBox: React.FC<IProps> = ({ min, max, value, label, holidays = [], onValueChanged, className, stylingMode, name, hint }) => {
    return <>
        <DateBox className={className} stylingMode={stylingMode} name={name} label={label} hint={hint}
            type="date" displayFormat={dateFormatter} min={min} max={max} value={value} calendarOptions={{
                cellTemplate: function (itemData) {
                    if (itemData.view !== "month") {
                        return itemData.text;
                    }

                    const date = itemData.date;
                    const isWeekendOrHoliday = isWeekend(date) || isHoliday(holidays, date);
                    return `<span class="${isWeekendOrHoliday ? "dx-custom-datebox-date-holiday" : ""}">${itemData.text}</span>`
                }
            }}
            onValueChanged={(e) => onValueChanged(e.value)}>
            <Validator>
                <RequiredRule />
            </Validator>
        </DateBox>
    </>
}

export default CustomDateBox;